import React from "react"
import FaIcon from "components/fa_icon"

function AnsweredExercise({exercise, index, on_click}) {
  const status = exercise.answer_status
  // Status can either be "skipped" or null for skipped questions
  const skipped = status === "skipped" || !status

  return (
    <div className={`question ${status}`} onClick={on_click}>
      <div className="question-inner">
        {exercise.image_url_thumb && <img src={exercise.image_url_thumb} alt=""
                                style={{width: "50px", height: "50px"}}/>}
        <div className="question-content">
          <div className="content">
            <span className="type">{index + 1}.</span>
            {exercise.question}
          </div>
        </div>
      </div>

      {status === "success" &&
        <div className="status-icon">
          <FaIcon name="fa-check" className="circle green"/>
        </div>}
      {status === "failed" &&
        <div className="status-icon">
          <FaIcon name="fa-times" className="circle red"/>
        </div>}
      {skipped &&
        <div className="status-icon">
          <FaIcon name="fa-minus" className="circle gray"/>
        </div>}
    </div>
  )
}

export default AnsweredExercise
